import { render, staticRenderFns } from "./RecipientPendingApproval.vue?vue&type=template&id=24fce9af"
import script from "./RecipientPendingApproval.vue?vue&type=script&lang=js"
export * from "./RecipientPendingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports